"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const FeedbackEventType_1 = require("../enums/FeedbackEventType");
class OfferFeedbackBodyRequestBase extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(FeedbackEventType_1.FeedbackEvent)),
    (0, base_models_1.Docs)({ example: FeedbackEventType_1.FeedbackEvent.OFFER_ACCEPTED, description: 'The stage of the offer.' }),
    tslib_1.__metadata("design:type", String)
], OfferFeedbackBodyRequestBase.prototype, "eventType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(FeedbackEventType_1.NotInterestedReason)),
    (0, base_models_1.Docs)({ example: FeedbackEventType_1.NotInterestedReason.WANTS_TO_WAIT, description: 'Required when eventType is CLIENT_NOT_INTERESTED. Feedback for the offer in case they were not interested.' }),
    tslib_1.__metadata("design:type", String)
], OfferFeedbackBodyRequestBase.prototype, "notInterestedReason", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'Customer is moving.', description: 'Required when eventType is FULFILLMENT_CANCELLED. Feedback for the offer in case they cancelled.' }),
    tslib_1.__metadata("design:type", String)
], OfferFeedbackBodyRequestBase.prototype, "fulfillmentCancelledReason", void 0);
exports.default = OfferFeedbackBodyRequestBase;
